// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)
import ActiveTabController from "./active_tab_controller"
application.register("active-tab", ActiveTabController)

import CleanQueryController from "./clean_query_controller"
application.register("clean-query", CleanQueryController)

import BulkSelectController from "./bulk_select_controller"
application.register("bulk-select", BulkSelectController)

import KeepOpenController from "./keep_open_controller"
application.register("keep-open", KeepOpenController)
import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)
import ResponsiveDisclosureController from "./responsive_disclosure_controller"
application.register("responsive-disclosure", ResponsiveDisclosureController)
import DateShortcutController from "./date_shortcut_controller"
application.register("date-shortcut", DateShortcutController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import QuickNavigationController from "./quick_navigation_controller"
application.register("quick-navigation", QuickNavigationController)
import UnsavedChangesController from "./unsaved_changes_controller"
application.register("unsaved-changes", UnsavedChangesController)

import ProductPreviewController from "./product_preview_controller"
application.register("product-preview", ProductPreviewController)

import TemplatePickerController from "./template_picker_controller"
application.register("template-picker", TemplatePickerController)

import SiteHeaderController from "./site_header_controller"
application.register("site-header", SiteHeaderController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import AiRunPollController from "./ai_run_poll_controller"
application.register("ai-run-poll", AiRunPollController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import PrintController from "./print_controller"
application.register("print", PrintController)
